import React, { useEffect } from 'react';
import { Button, Form, Input, message } from 'antd';
import { MinusCircleOutlined, PlusOutlined } from '@ant-design/icons';
import { reqUpdataRole } from '../../../../api';

// 表单布局设置
const formItemLayout = {
  labelCol: { xs: { span: 24 }, sm: { span: 4 } },
  wrapperCol: { xs: { span: 24 }, sm: { span: 20 } },
};

const formItemLayoutWithOutLabel = {
  wrapperCol: { xs: { span: 24, offset: 0 }, sm: { span: 20, offset: 4 } },
};

const ShowAuth = ({
  role,
  setForm,
  cancelAdd,
  getRoles,
  currentPage,
  roleType,
}) => {
  const [form] = Form.useForm();

  // 设置表单和重置表单
  useEffect(() => {
    setForm(form);
    form.resetFields();
  }, [form, setForm]);

  // 表单提交
  const onFinish = async values => {
    const data = {
      type: roleType,
      ...values,
    };
    const result = await reqUpdataRole(role.role_id, data);
    // 处理请求结果
    if (result.status === 200) {
      message.success('修改角色成功');
      cancelAdd();
      getRoles(currentPage);
    } else {
      message.error(result.error);
    }
  };

  return (
    <Form
      form={form}
      name='role_auth'
      {...formItemLayoutWithOutLabel}
      onFinish={onFinish}
    >
      <Form.List
        name='permissions'
        initialValue={role.permissions || []}
      >
        {(fields, { add, remove }, { errors }) => (
          <>
            {fields.map((field, index) => (
              <Form.Item
                {...(index === 0 ? formItemLayout : formItemLayoutWithOutLabel)}
                label={index === 0 ? 'auth' : ''}
                required={false}
                key={field.key}
              >
                <Form.Item
                  {...field}
                  validateTrigger={['onChange', 'onBlur']}
                  noStyle
                >
                  <Input
                    placeholder='请输入权限'
                    style={{ width: '60%' }}
                  />
                </Form.Item>
                <MinusCircleOutlined onClick={() => remove(field.name)} />
              </Form.Item>
            ))}
            <Form.Item>
              <Button
                type='dashed'
                onClick={() => add()}
                style={{ width: '60%' }}
                icon={<PlusOutlined />}
              >
                增加权限
              </Button>
              <Form.ErrorList errors={errors} />
            </Form.Item>
          </>
        )}
      </Form.List>
      <Form.Item>
        <Button
          type='primary'
          htmlType='submit'
        >
          保存
        </Button>
      </Form.Item>
    </Form>
  );
};

export default ShowAuth;
